const Onboarding = 'https://images.unsplash.com/photo-1485796826113-174aa68fd81b?fit=crop&w=840&q=80';
const Products = {
  'Auto': 'https://images.unsplash.com/photo-1533106418989-88406c7cc8ca?fit=crop&w=840&q=80',
  'Motocycle': 'https://images.unsplash.com/photo-1512798428556-626e79a5d83a?fit=crop&w=840&q=80',
  'Watches': 'https://images.unsplash.com/photo-1434056886845-dac89ffe9b56?fit=crop&w=840&q=80',
  'Makeup': 'https://images.unsplash.com/photo-1526045478516-99145907023c?fit=crop&w=840&q=80',
  'Accessories': 'https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?fit=crop&w=840&q=80',
  'Fragrance': 'https://images.unsplash.com/photo-1537349564218-ad1b0c334032?fit=crop&w=840&q=80',
  'BMW': 'https://images.unsplash.com/photo-1536676442959-4a7ce781e8c8?fit=crop&w=840&q=80',
  'Mustang': 'https://images.unsplash.com/photo-1516661874749-3a8e9d1a8f18?fit=crop&w=840&q=80',
  'Harley-Davidson': 'https://images.unsplash.com/photo-1515777315835-281b94c9589f?fit=crop&w=840&q=80',
};

const Profile = 'https://images.unsplash.com/photo-1512529920731-e8abaea917a5?fit=crop&w=840&q=80';
const Avatar = 'https://images.unsplash.com/photo-1518725522904-4b3939358342?fit=crop&w=210&q=80';

const Viewed = [
  'https://images.unsplash.com/photo-1508264443919-15a31e1d9c1a?fit=crop&w=240&q=80',
  'https://images.unsplash.com/photo-1497034825429-c343d7c6a68f?fit=crop&w=240&q=80',
  'https://images.unsplash.com/photo-1487376480913-24046456a727?fit=crop&w=240&q=80',
  'https://images.unsplash.com/photo-1494894194458-0174142560c0?fit=crop&w=240&q=80',
  'https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?fit=crop&w=240&q=80',
  'https://images.unsplash.com/photo-1542068829-1115f7259450?fit=crop&w=240&q=80',
];

export default {
  Onboarding,
  Products,
  Profile,
  Viewed,
  Avatar,
}